import React, { useContext, useEffect, useState } from 'react';
import { UserPicture } from '../../atoms';
import { IProps } from './types';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { AuthContext } from '@/contexts';
import { useNavigate } from 'react-router-dom';


export const UserProfile: React.FC<IProps> = ({
    firstname,
    lastname,
    imageURL,
}) => {
    const { signOut } = useContext(AuthContext);
    const [mustLogOut, setMustLogOut] = useState(false);
    const navigate = useNavigate();

    const signOutAction = async (e: any) => {
        e.preventDefault();
        await signOut();
        setMustLogOut(true);
    }

    useEffect(() => {
        if (mustLogOut) {
            navigate('/');
        }
        return () => {
        }
    }, [mustLogOut])

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <UserPicture username={firstname} firstname={firstname} lastname={lastname} imageURL={imageURL} />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56" align="start">
                <DropdownMenuLabel>{firstname} {lastname}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={signOutAction} variant='destructive'>
                    Cerrar sesión
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>

    )
}